
<template>
  <div id="jl-bigscreen">
    <bigdatamonitoring :isFullScreen="true"></bigdatamonitoring>
  </div>
</template>
<script>
import {reqFullScreen} from "./js/utils";
import bigdatamonitoring from "@/views/bigscreen/bigdatamonitoring";
export default {
  components:{
    bigdatamonitoring
  },
  mounted() {
    this.onFullScreen()
  },
  methods:{
    onFullScreen(){
      reqFullScreen()
    }
  }
}
</script>
